import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { ArrowRight } from 'lucide-react';
import AnimateOnScroll from './AnimateOnScroll';

const Hero = () => {
  const { t } = useLanguage();

  const scrollToProjects = () => {
    document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative min-h-screen bg-neutral-900 overflow-hidden">
      {/* Background Video - starts below navbar */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
        >
          <source src="https://customer-assets.emergentagent.com/job_archspace-12/artifacts/h7cswp30_MIH_video_homepage.mp4" type="video/mp4" />
        </video>
        {/* Subtle overlay for readability */}
        <div className="absolute inset-0 bg-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 min-h-screen flex items-center pt-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left - Text Content - WHITE, less bold */}
            <div className="space-y-8">
              <AnimateOnScroll animation="fade-up">
                <p className="text-white text-sm tracking-[0.3em] uppercase">
                  my iHome SA
                </p>
              </AnimateOnScroll>
              
              <AnimateOnScroll animation="fade-up" delay={1}>
                <h1 className="text-5xl md:text-7xl lg:text-8xl font-medium leading-[0.9]">
                  <span className="block text-white">Architecture</span>
                  <span className="block text-white">et construction</span>
                  <span className="block text-white">durable</span>
                </h1>
              </AnimateOnScroll>

              <AnimateOnScroll animation="fade-up" delay={2}>
                <p className="text-white/90 text-lg max-w-md leading-relaxed">
                  {t({ 
                    fr: 'Pionnière en Suisse depuis plus de 12 ans, my iHome SA concrétise vos projets de construction durable.',
                    en: 'Pioneer in Switzerland for over 12 years, my iHome SA brings your sustainable construction projects to life.'
                  })}
                </p>
              </AnimateOnScroll>

              <AnimateOnScroll animation="fade-up" delay={3}>
                <div className="flex flex-col sm:flex-row gap-4 pt-4">
                  <button
                    onClick={scrollToProjects}
                    className="group inline-flex items-center space-x-3 text-white border-2 border-white px-8 py-4 hover:bg-white hover:text-neutral-900 transition-all duration-300 font-medium"
                  >
                    <span>{t({ fr: 'Voir les projets', en: 'View projects' })}</span>
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </button>
                  <button
                    onClick={scrollToContact}
                    className="group inline-flex items-center space-x-3 text-neutral-900 bg-white px-8 py-4 hover:bg-neutral-200 transition-all duration-300 font-medium"
                  >
                    <span>{t({ fr: 'Nous contacter', en: 'Contact us' })}</span>
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </button>
                </div>
              </AnimateOnScroll>
            </div>

            {/* Right - Stats - Only 12+ and 50+ */}
            <div className="hidden lg:block">
              <AnimateOnScroll animation="fade-left" delay={2}>
                <div className="grid grid-cols-1 gap-8">
                  <div className="border-l-2 border-white/50 pl-6">
                    <p className="text-5xl font-medium text-white">12+</p>
                    <p className="text-white/80 mt-2">{t({ fr: 'Années d\'expérience', en: 'Years of experience' })}</p>
                  </div>
                  <div className="border-l-2 border-white/50 pl-6">
                    <p className="text-5xl font-medium text-white">50+</p>
                    <p className="text-white/80 mt-2">{t({ fr: 'Projets réalisés', en: 'Completed projects' })}</p>
                  </div>
                </div>
              </AnimateOnScroll>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-px h-16 bg-gradient-to-b from-white to-transparent"></div>
      </div>
    </section>
  );
};

export default Hero;
